import { utils, LitElement, html, broadcastReceiver } from '@hh/global.js'

const { serializeForm, addToCart, reRenderShopifySections, processGWP } = utils

class HHProductForm extends LitElement {
  static properties = {
    showMiniCartAfterSubmission: {
      type: Boolean,
      attribute: 'show-mini-cart',
    },
  }

  constructor() {
    super()

    this.form = this.querySelector('form')
    this.quanityInput = this.querySelector('[name="quantity"]')
    this.showQuickAdd = this.querySelector('.js-show-quick-add')
    this.variantButtons = this.querySelectorAll('.js-swatch')

    this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
    this.showQuickAdd?.addEventListener('click', () => {
      this.classList.add('is-active')
    })

    this.addEventListener('mouseleave', () => {
      this.classList.remove('is-active')
    })

    this.variantButtons.forEach((button) => {
      button.addEventListener('focus', this.onFocusHandler.bind(this))
      button.addEventListener('blur', this.onBlurHandler.bind(this))
    })
  }

  connectedCallback() {
    super.connectedCallback()

    this.receiver = broadcastReceiver('quantity', (...args) => {
      this.getQuantityFromDocument(...args)
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.receiver?.disconnect()
  }

  getQuantityFromDocument(data) {
    if (this.quanityInput) {
      this.quanityInput.value = data.value || 1
    }
  }

  get showAlert() {
    return this.dataset.showAlert
  }

  async onSubmitHandler(event) {
    event.preventDefault()

    reRenderShopifySections(
      await addToCart(JSON.parse(serializeForm(this.form)))
    )

    if (this.showMiniCartAfterSubmission) {
      document.body.classList.add('mini-cart-is-active')
    }

    await processGWP()

    if (this.showAlert == 'true') {
      this.dispatchEvent(
        new CustomEvent('productAdded', {
          bubbles: true,
          composed: true,
          detail: {
            id: 'cart-notification',
          },
        })
      )
    }
  }

  onFocusHandler() {
    this.classList.add('is-active')
  }

  onBlurHandler() {
    setTimeout(() => {
      if (
        !Array.from(this.variantButtons).some(
          (button) => button === document.activeElement
        )
      ) {
        this.classList.remove('is-active')
      }
    }, 0)
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-form', HHProductForm)
